import React, { useState, useEffect, useRef } from 'react';
import { Form } from 'react-bootstrap';
import '../../../../../../assets/scss/user.scss';
import 'react-datepicker/dist/react-datepicker.css';
import { upSert } from 'services/bs-sector-measurable/measurableDataService';
import { buildTargetTextDisplay } from 'helpers/kpiHelper';
import { inputPopulateType } from 'data/TempData';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { QueueButton } from './QueueButton';
import { queue } from 'services/bs-sector-measurable/measurableDataService';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import './MesuarableTdItem.css';
import { toast } from 'react-toastify';
import { QueueTooltip } from './QueueTooltip';
import { useQueues } from './useQueues';
import { checkColor } from './kpiColor.util';

MesuarableTdItem.propTypes = {
  data: PropTypes.array,
  item: PropTypes.object,
  col: PropTypes.string,
  value: PropTypes.string,
  callback: PropTypes.func,
  noOfCol: PropTypes.number,
  sheduleTypeId: PropTypes.number,
  compareNoOfCol: PropTypes.number
};

export function MesuarableTdItem({
  data,
  item,
  col,
  value,
  callback,
  noOfCol,
  compareNoOfCol,
  sheduleTypeId
}) {
  const [idCellEditing, setIdCellEditing] = useState('');
  const [inputValue, setInputValue] = useState(0);
  const inputRef = useRef(null);
  const ManualEnterText = 'Manual Enter';
  const FormulaText = 'Formula';
  const [numberDisplay, setNumberDisplay] = useState('TBC');
  const [objDataColor, setObjDataColor] = useState({});
  const [classColor, setClassColor] = useState('');
  const [showTooltip, setShowTooltip] = useState(false);

  const { queues, loading, refetch } = useQueues({
    item,
    col,
    showTooltip
  });
  const needQueue =
    inputPopulateType.find(x => x.value === item.inputMethod)?.label ===
    ManualEnterText || inputPopulateType.find(x => x.value === item.inputMethod)?.label == FormulaText;

  useEffect(() => {
    if (idCellEditing === `${col} ${item.id}` && inputRef.current) {
      inputRef.current.focus();
    }
  }, [idCellEditing, col, item.id]);

  useEffect(() => {
    setInputValue(value);
  }, [value]);

  useEffect(() => {
    let calNumber = value;
    // if (
    //   inputPopulateType.find(x => x.value === item.inputMethod)?.label ===
    //   FormulaText
    // ) {
    //   calNumber = applyFormula(data, item, col);
    // }
    setNumberDisplay(calNumber);
    setObjDataColor({ date: new Date(col), value: calNumber });
  }, [data, item.inputMethod, col, value, sheduleTypeId]);

  useEffect(() => {
    setClassColor(
      checkColor(
        item.variationPercentage,
        objDataColor,
        item.currentMonthTarget,
        item.previousMonthTarget,
        item.compareType
      )
    );
  }, [objDataColor]);
  const handleClick = () => {
    const inputMethod = inputPopulateType.find(
      x => x.value == item.inputMethod
    );
    if (inputMethod?.label == ManualEnterText) {
      setIdCellEditing(`${col} ${item.id}`);
    }
  };

  const handleOnBlur = () => {
    setIdCellEditing('');
    if (inputValue != value && inputValue != '') {
      upSert(item.id, col, inputValue, sheduleTypeId).then(() => {
        callback();
      });
    }
  };

  const buildDisplayText = () => {
    const data =
      inputPopulateType.find(x => x.value === item.inputMethod)?.label ===
      FormulaText
        ? numberDisplay
        : value;
    return buildTargetTextDisplay(
      item.targetTypeValue,
      data,
      item.targetType,
      item.numOfDecimal
    );
  };

  return (
    <td
      className={classNames('text-center p-1', classColor)}
      hidden={compareNoOfCol < noOfCol}
    >
      <div
        onClick={handleClick}
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          gap: '6px'
        }}
      >
        {`${col} ${item.id}` === idCellEditing ? (
          <Form.Control
            ref={inputRef}
            type="number"
            onChange={e => setInputValue(e.target.value)}
            value={inputValue}
            onBlur={handleOnBlur}
            onKeyDown={e => e.key === 'Enter' && handleOnBlur()}
          />
        ) : (
          <OverlayTrigger
            placement="top"
            trigger={['hover', 'focus']}
            onToggle={setShowTooltip}
            overlay={
              <Tooltip>
                <QueueTooltip loading={loading} queues={queues} />
              </Tooltip>
            }
          >
            <span
              style={{
                fontWeight: 500,
                cursor: loading ? 'wait' : 'pointer'
              }}
            >
              {buildDisplayText()}
            </span>
          </OverlayTrigger>
        )}
        {!needQueue && (
          <QueueButton
            classColor={classColor}
            onClick={e => {
              e.stopPropagation();
              const isoStr = col.replace(' ', 'T');
              queue({
                measurableId: item.id,
                date: isoStr,
                scheduleType: item.scheduleType
              })
                .then(() => {
                  toast.success('Queue created successfully!!');
                  refetch();
                })
                .catch(() => {
                  toast.error('Queue failed ❌');
                });
            }}
          />
        )}
      </div>
    </td>
  );
}
